import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.object.is-extensible";
import "core-js/modules/es6.object.assign";

var scope_0 = require('/Users/llorentegerman/Documents/code/otros/react-collapsible-content/docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/00966d5458a60b959ef322789a9f6b81.js')["default"];

var scope_1 = require('/Users/llorentegerman/Documents/code/otros/react-collapsible-content/docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/461f202ff0ecc4c6bc6b7769f3c2f740.js')["default"];

var scope_2 = require('/Users/llorentegerman/Documents/code/otros/react-collapsible-content/docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/50aa66affdb3f1322d49d61e242f25eb.js')["default"];

var scope_3 = require('/Users/llorentegerman/Documents/code/otros/react-collapsible-content/docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/6ff172110c45facf5cdaba3b6d7ca2aa.js')["default"];

var scope_4 = require('/Users/llorentegerman/Documents/code/otros/react-collapsible-content/docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/9ee8580b441c703ac8651b5b254c256b.js')["default"];

var scope_5 = require('/Users/llorentegerman/Documents/code/otros/react-collapsible-content/docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d96483f03fea80bb625feb6714be9472.js')["default"];

var scope_6 = require('/Users/llorentegerman/Documents/code/otros/react-collapsible-content/docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js')["default"];

var scope_7 = require('/Users/llorentegerman/Documents/code/otros/react-collapsible-content/docz/.docz/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/fce3cfa097c2abb379c5f11c719f852d.js')["default"];

var __DOCZ_DUMMY_EXPORT_DEFAULT = Object.assign({}, scope_0, scope_1, scope_2, scope_3, scope_4, scope_5, scope_6, scope_7);

export default __DOCZ_DUMMY_EXPORT_DEFAULT;

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}

if (typeof __DOCZ_DUMMY_EXPORT_DEFAULT !== 'undefined' && __DOCZ_DUMMY_EXPORT_DEFAULT && __DOCZ_DUMMY_EXPORT_DEFAULT === Object(__DOCZ_DUMMY_EXPORT_DEFAULT) && Object.isExtensible(__DOCZ_DUMMY_EXPORT_DEFAULT) && !__DOCZ_DUMMY_EXPORT_DEFAULT.hasOwnProperty('__filemeta')) {
  Object.defineProperty(__DOCZ_DUMMY_EXPORT_DEFAULT, '__filemeta', {
    configurable: true,
    value: {
      name: "__DOCZ_DUMMY_EXPORT_DEFAULT",
      filename: "node_modules/gatsby-plugin-mdx/loaders/mdx-scopes.js"
    }
  });
}